import {useTranslation} from '../../i18n/translation';
import React from "react";
import Navigation from "../utils/Navigation";
import "../../css/about/company.css";
import "../../css/about/about-refresh.css";

import {NewsPhoto} from "../news/NewsCard";
import {Link, useLocation} from "react-router-dom";
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";

// Картинки теперь в public → строковые URL.
const bridge = "/images/about/company/iconBridge.webp";
const stanok = "/images/about/company/iconStanok.webp";
const silos  = "/images/about/company/iconSilos.webp";

const img1  = "/images/about/company/image_sespel_1.webp";
const img2  = "/images/about/company/image_sespel_2.webp";
const img3  = "/images/about/company/image_sespel_3.webp";
const img4  = "/images/about/company/image_sespel_4.webp";
const img5  = "/images/about/company/image_sespel_5.webp";
const img6  = "/images/about/company/image_sespel_6.webp";
const img7  = "/images/about/company/image_sespel_7.webp";
const img8  = "/images/about/company/image_sespel_8.webp";
const img9  = "/images/about/company/image_sespel_9.webp";
const img10 = "/images/about/company/image_sespel_10.webp";
const img11 = "/images/about/company/image_sespel_11.webp";
const img12 = "/images/about/company/image_sespel_12.webp";

export function CompanyMainIndicatorsText({bigText, smallText, vertical=false, valueTag: ValueTag = 'h1'}){
    const {t} = useTranslation();

    const {theme} = useTheme()

    return (
        <div className={`company-indicators-text ${theme} ${vertical? "company-indicators-text-vertical" : "company-indicators-text-horizontal"}`}>
            <ValueTag>{bigText}</ValueTag>
            <p>{t(smallText)}</p>
        </div>
    )
}

export default function Company() {
    const {english, t} = useTranslation();

    const location = useLocation();
    const siteData = findElementByLink(siteStructure, location.pathname.replace(/^\/en(?=\/|$)/, '') || '/')
    const seo = siteData !== null && siteData.seo? siteData.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}
    const { theme } = useTheme()

    return (
        <>
            <SeoHelmet
                title={t(seo.title)}
                description={t(seo.description)}
                keywords={seo.keywords ? t(seo.keywords) : undefined}
            />
            <Navigation/>
            <div className={`complexBack ${theme}`}> </div>

            <main className={`company-container about-page company-refresh ${theme}`}>
                <header className="company-hero">
                    <div className="company-hero-copy">
                        <span className="about-eyebrow">{t("Сеспель / О предприятии")}</span>
                        <h1>{t("Технологии, которые")}<br/>{t("двигают вперёд")}</h1>
                        <p>{t("Чебоксарское предприятие «Сеспель» — производство специализированной техники, современные материалы и собственные инженерные решения.")}</p>
                        <div className="about-actions">
                            <a className="about-button" href="#company-products">{t("Наша продукция")}<span aria-hidden="true">↗</span></a>
                            <Link className="about-text-link" to={english ? "/en/about/contacts" : "/about/contacts"}>{t("Связаться с нами")}<span aria-hidden="true">↗</span></Link>
                        </div>
                    </div>
                    <figure className="company-hero-photo">
                        <img src={img6} alt={t("Производственная площадка предприятия Сеспель")}/>
                        <figcaption>{t("Инженерная мысль. Производственная точность.")}</figcaption>
                    </figure>
                </header>

                <Description title={"Производство в деталях"} content={<Content theme={theme}/>}
                             images={[img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12]}/>

                <div className="about-section-heading">
                    <span className="about-eyebrow">{t("02 / Масштаб предприятия")}</span>
                    <h2>{t("Сеспель в цифрах")}</h2>
                </div>
                <CompanyMainIndicatorsContent/>

                <div className="about-section-heading" id="company-products">
                    <span className="about-eyebrow">{t("03 / Направления")}</span>
                    <h2>{t("Основная продукция")}</h2>
                </div>
                <CompanyMainProductsContent/>
                <section className="company-contact-strip">
                    <div><h2>{t("Решение под вашу задачу")}</h2><p>{t("Обсудите с нами выбор техники и возможности производства.")}</p></div>
                    <Link className="about-button" to={english ? "/en/about/contacts" : "/about/contacts"}>{t("Обсудить задачу")}<span aria-hidden="true">↗</span></Link>
                </section>
            </main>

        </>
    );
}

function Description({title, content, images}) {
    const {t} = useTranslation();
    return (
        <section className="company-story" aria-labelledby="company-story-title">
            <div className="about-section-heading">
                <span className="about-eyebrow">{t("01 / Наш подход")}</span>
                <h2 id="company-story-title">{t(title)}</h2>
            </div>
            <div className="company-story-grid">
                <div className="company-gallery"><NewsPhoto images={images}/><p>{t("Производственные площадки и оборудование предприятия")}</p></div>
                <div className="company-story-content">{content}</div>
            </div>
        </section>
    );
}

function CompanyMainProducts({images, titles, texts}){
    const {t} = useTranslation();

    return (
        <div className={"company-product"}>
            <div className={"company-product-imageWrapper"}>
                {images.map((img,i)=>{
                    return <img key={`img-${i}`} src={img} alt="" loading="lazy"/>
                })}
            </div>

            {titles.map((title, i)=> {
                return <div key={`title-${i}`}>
                    <h3>{t(title)}</h3>
                    {texts[i]? texts[i].map((text, j)=>{
                        return <p key={`text-${i}-${j}`}>{t(text)}</p>
                    }) : null}
                </div>
            })}

        </div>
    )
}

function Content({theme}) {
    const {t} = useTranslation();
    return (
        <>
            <div className={`company-product-description ${theme}`}>
                <p>{t("Целью деятельности предприятия является оказание всесторонней поддержки нашим клиентам, работающим в сфере транспорта, строительства, сельского хозяйства, нефтегазового комплекса, химической, пищевой и перерабатывающей промышленности.")}</p>

                <p>{t("Нашей первоочередной задачей является безусловное ориентирование на Ваши потребности. Для этого мы прислушиваемся к Вам, адаптируя свои решения к Вашим индивидуальным нуждам и готовы в любой ситуации оказать Вам необходимую помощь и предлагаем Вам широкий спектр специализированных цистерн. Номенклатурный ряд которых составляет более 150 моделей из низколегированной, нержавеющей стали и алюминиевого сплава.")}</p>

                <p>{t("Мы производим и поставляем полуприцепы, цистерны - цементовозы, муковозы, бензовозы, нефтевозы, битумовозы, цистерны подъемного типа, водовозы, комбикормовозы, цистерны для химической продукции. Наш многолетний опыт работы в качестве одного из ведущих Российских поставщиков специализированной техники делает нас компетентным партнером в области решений по перевозке сыпучих и жидких грузов.")}</p>

            </div>
            <div className={`company-product-description ${theme}`}>

                <strong>{t("ПРИОБРЕТАЯ ТЕХНИКУ ЗАО «ЧЕБОКСАРСКОЕ ПРЕДПРИЯТИЕ «СЕСПЕЛЬ», ВЫ ПОЛУЧАЕТЕ:")}</strong>
                <ul>
                    <li>{t("инновационные технические решения в производстве техники, обеспечивающие эффективность производственных процессов и выполнение самых строгих требований клиентов;")}</li>
                    <li>{t("поддержку предприятия по техобслуживанию техники на производственной площадке завода, дилеров и сервисных площадках партнеров, расположенных во многих регионах России, обеспечивая этим легкую территориальную доступность;")}</li>
                    <li>{t("специализированные цистерны, собранные на новейшем технологическом оборудовании импортного и российского производства, максимально адаптированные к Российским дорогам, по ценам на 40%-80% ниже цен производителей аналогичной европейской техники.")}</li>
                </ul>

                <br/>

                <strong>{t("ДРУГИЕ ПРЕИМУЩЕСТВА:")}</strong>
                <ul>
                    <li>{t("Уникальные технологии производства и современное оборудование;")}</li>
                    <li>{t("Использование в производстве высокопрочных материалов;")}</li>
                    <li>{t("Инновационный контроль качества продукции;")}</li>
                    <li>{t("Разработка и производство спецтехники по индивидуальным заказам;")}</li>
                    <li>{t("Постоянно в наличии на складе более 100 единиц техники;")}</li>
                    <li>{t("Комплексные центры сервисного оборудования по всей России.")}</li>
                </ul>
            </div>
        </>
    )
}

function CompanyMainIndicatorsContent() {

    function createIndicatorsContent(bigText, smallText) {
        return {bigText, smallText, valueTag: 'strong'}
    }

    const content = {
        years: createIndicatorsContent("33", "года на рынке"),
        area: createIndicatorsContent("30 000", "кв.м. производственных площадей"),
        shop: createIndicatorsContent("7", "цехов"),
        research: createIndicatorsContent("3", "исследовательских центра"),
        employee: createIndicatorsContent("700", "сотрудников"),
        age: createIndicatorsContent("39", "лет средний возраст"),
        revenue: createIndicatorsContent(">6 000", "млн. руб. выручка компании за 2024 год"),
        invistibles: createIndicatorsContent(">500", "млн. руб. инвестиции в R&D"),
        ppc: createIndicatorsContent(">10 000", "произведенных полуприцепов"),
        machine: createIndicatorsContent(">20", "произведенных уникальных станочных комплексов"),
        welding: createIndicatorsContent(">300", "км/год сварки"),
        molding: createIndicatorsContent(">1 000", "т/год промышленного литья"),
    }

    return (
        <div className={"company-main-indicators"}>
            <div>
                <div>
                    <CompanyMainIndicatorsText {...content.years} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.area} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.shop} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.research} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.employee} vertical={true}/>
                    <CompanyMainIndicatorsText {...content.age} vertical={true}/>
                </div>
            </div>
            <div>
                <CompanyMainIndicatorsText {...content.ppc} vertical={true}/>
                <CompanyMainIndicatorsText {...content.machine} vertical={true}/>
                <CompanyMainIndicatorsText {...content.welding} vertical={true}/>
                <CompanyMainIndicatorsText {...content.molding} vertical={true}/>
                <CompanyMainIndicatorsText {...content.invistibles} vertical={true}/>
                <CompanyMainIndicatorsText {...content.revenue} vertical={true}/>
            </div>
        </div>
    )
}

function CompanyMainProductsContent() {

    function createProductsContent(images, titles, texts) {
        return {images, titles, texts}
    }

    const content = {
        bridge: createProductsContent([bridge],["Алюминиевые мосты"],
            [["Пролеты от 12 до 18 м", "Длина моста 50-250 м"]]),
        silos: createProductsContent([silos],["Алюминиевые силосы и резервуары"],
            [["Высота от 7,6 до 50 м", "Диаметр от 2,4 м до", "неограниченно"]]),
        stanok: createProductsContent([stanok],["Станочные комплексы"],
            [["СТП Прогресс","СТП Сеспель","СТП Зерновоз","СТП 4ПЛ","СТП ШВП","РТК Лазер","Мобильный СТП","Проект Центратор", "Проект КЛОН", "и др."]]),
    }

    return (
        <div className={"company-products"}>
            <CompanyMainProducts {...content.bridge}/>
            <CompanyMainProducts {...content.silos}/>
            <CompanyMainProducts {...content.stanok}/>
        </div>
    )
}
